import {apiMemberserviceEndpoint} from '@/config/config.js';
import { createApiClient } from "@/services/baseservice.js"

const apiScope = 'api://memberservice-api/Member.Read'

const baseservice = createApiClient(apiScope, apiMemberserviceEndpoint)

export default {
    async update(contactPersonId, contactPerson) {
        return await baseservice.put('/contactpersons/' + contactPersonId, contactPerson,
            { baseURL: apiMemberserviceEndpoint }
        )
    },
};
